import React, { useCallback, useEffect, useState } from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import SkillDialog from "./SkillForm";
import ToolBar from "../../components/Layout/ToolBar";
import useTable from '../../components/useTable';
import * as skillService from '../../services/skillService';
import ActionsTableCell from '../../components/MaterialTable/ActionsTableCell';
import useAlert from '../../components/useAlert';
import useLinearProgress from '../../components/useLinearProgress';
import AlertDialog from '../../components/AlertDialog';

const skillColumns = [
    { id: 'id', label: 'ID' },
    { id: 'name', label: 'Name' },
    { id: 'projectId', label: 'Project ID' },
    { id: 'language', label: 'Language' },
];

const SKILL_DIALOGS = {
    CREATE_EDIT_DIALOG: 'skill',
    CONFIRMATION_DIALOG: 'alert'
}

const Skills = () => {
    const [skills, setSkills] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [open, setOpen] = useState(false);
    const [dialogType, setDialogType] = useState("");

    const {
        TblContainer,
        TblHead
    } = useTable(skills, skillColumns);

    const {
        Alert,
        status,
        showSuccess,
        showError
    } = useAlert();

    const {
        LinearPorgress,
        isLoading,
        setIsLoading
    } = useLinearProgress(true);

    const getSkills = useCallback(() => {
        skillService.getSkills()
            .then((response) => {
                const result = response.data.items;
                setSkills(result || []);
            })
            .catch(error => {
                showError(error.response?.data?.message || "Error fetching Skills");
            }).finally(() => {
                setIsLoading(false);
            });
    }, [showError, setIsLoading]);

    useEffect(() => {
        getSkills();
    }, [getSkills]);

    const handleDeleteClicked = () => {
        skillService.removeSkill(selectedRow.id)
            .then(() => {
                showSuccess();
                getSkills();
            }).catch(error => {
                showError(error.response?.data?.message || "Error deleting Skill");
            });
    }

    return (
        <React.Fragment>
            {status ? <Alert /> : null}
            <ToolBar
                title="Add Skill"
                setOpen={() => {
                    setSelectedRow(null);
                    setDialogType(SKILL_DIALOGS.CREATE_EDIT_DIALOG);
                    setOpen(true);
                }}
            />
            {isLoading ? <LinearPorgress /> :
            <TblContainer>
                <TblHead />
                <TableBody>
                    {skills && skills.map(key => (
                        <TableRow
                            key={key.id}
                            onClick={() => setSelectedRow(key)}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell >{key.id}</TableCell>
                            <TableCell >{key.name}</TableCell>
                            <TableCell >{key.projectId}</TableCell>
                            <TableCell >{key.language}</TableCell>
                            <ActionsTableCell
                                onEdit={() => {
                                    setDialogType(SKILL_DIALOGS.CREATE_EDIT_DIALOG);
                                    setOpen(true);
                                }}
                                onDelete={(e) => {
                                    setDialogType(SKILL_DIALOGS.CONFIRMATION_DIALOG);
                                    setOpen(true);
                                }}
                            />
                        </TableRow>
                    ))}
                </TableBody>
            </TblContainer>}
            {dialogType === SKILL_DIALOGS.CREATE_EDIT_DIALOG ?
                <SkillDialog
                    open={open}
                    setOpen={setOpen}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    getSkills={getSkills}
                />
                : dialogType === SKILL_DIALOGS.CONFIRMATION_DIALOG ?
                    <AlertDialog
                        open={open}
                        setOpen={setOpen}
                        setSelectedRow={setSelectedRow}
                        confirmAction={handleDeleteClicked}
                    />
                    : null
            }
        </React.Fragment>
    );
}

export default Skills;
